<template>
    <dx-form :form-data="formData" ref="formRef">
        <dx-group-item :col-count="columnCount">
            <dx-simple-item
                :label="{ text: firstPropsObject?.label }"
                :data-field="firstPropsObject?.dataField"
                :editor-type="firstPropsObject?.editorType"
                :editor-options="firstPropsObject?.editorOptions.value"
                :is-required="firstPropsObject?.isRequired"
            />
            <dx-simple-item
                :label="{ text: secondPropsObject?.label }"
                :data-field="secondPropsObject?.dataField"
                :editor-type="secondPropsObject?.editorType"
                :editor-options="secondPropsObject?.editorOptions.value"
                :is-required="secondPropsObject?.isRequired"
            >
                <dx-async-rule
                    :validation-callback="validateVacationDatesRange"
                    message="Окончание блокировки не может быть раньше ее начала"
                />
            </dx-simple-item>

            <dx-simple-item
                :label="{ text: thirdPropsObject?.label }"
                :is-required="thirdPropsObject?.isRequired"
                :data-field="thirdPropsObject?.dataField"
                editor-type="dxTagBox"
                :editor-options="tagBoxOptions"
            />
        </dx-group-item>
    </dx-form>
</template>
<script>
export default {
    name: 'ai-form-dates-select-text-box',
};
</script>
<script setup>
import { watch, computed, ref, onMounted } from 'vue';
import { DxForm, DxSimpleItem, DxGroupItem, DxAsyncRule } from 'devextreme-vue/form';
import moment from 'moment';

import usersStore from '@/store/administration/users';
import { state, getLockReasons } from '@/service/admin-service';
const { setLockFormRef } = usersStore;

const emit = defineEmits(['addNewItem']);
const formRef = ref();

const props = defineProps({
    firstPropsObject: {
        type: Object,
    },
    secondPropsObject: {
        type: Object,
    },
    thirdPropsObject: {
        type: Object,
    },
    columnCount: {
        type: Number,
        default: 1,
    },
    dataSource: {
        type: Array,
    },
    disabled: {
        type: Boolean,
    },
    formData: {
        type: Object,
    },
});

onMounted(async () => {
    state.lockReasons = await getLockReasons();
});

onMounted(() => {
    setLockFormRef(formRef.value);
});

watch(
    [() => props.formData[props.firstPropsObject.dataField]],
    async () => {
        await validateVacationDatesRange();
    },
    { deep: true }
);

const validateVacationDatesRange = async () => {
    let firstDate;
    let secondDate;
    await Promise.resolve()
        .then(() => (firstDate = moment(props.formData[props.firstPropsObject.dataField])))
        .then(() => (secondDate = moment(props.formData[props.secondPropsObject.dataField])));
    return secondDate.isSameOrAfter(firstDate);
};

const onCustomItemCreating = args => {
    const newItem = {
        id: new Date().getTime(),
        name: args.text,
    };
    emit('addNewItem', newItem);
    args.customItem = newItem;
};

watch(
    () => props.thirdPropsObject?.disabled,
    newVal => {
        tagBoxOptions.value.disabled = newVal;
    }
);

let tagBoxOptions = computed(() => ({
    dataSource: state.lockReasons,
    readOnly: props.thirdPropsObject?.readOnly,
    displayExpr: 'name',
    valueExpr: 'name',
    width: props.thirdPropsObject?.width,
    wrapItemText: true,
    showClearButton: true,
    acceptCustomValue: true,
    onCustomItemCreating: onCustomItemCreating,
    onValueChanged: function (e) {
        const value = e.value;
        if (value && value.length > 1) {
            e.component.option('value', [value[value.length - 1]]);
        }
    },
}));

const fieldValidate = () => {
    return formRef.value.instance?.validate();
};

defineExpose({
    fieldValidate,
});
</script>
<style lang="scss" scoped>
:deep(.dx-tag-content) {
    background-color: transparent;
    border: none;
    color: black;
    border-radius: 0;
    padding: 2px 0px 0px 1px;
}
:deep(.dx-tag-content:hover) {
    background-color: transparent;
    border: none;
    color: black;
    overflow: auto;
}
:deep(.dx-texteditor-container) {
    max-height: 48px;
}
:deep(.dx-tag-remove-button) {
    display: none;
}
</style>
